import { useMutation, useQuery } from "react-query";
import axios, { AxiosError } from "axios";

const publicHttp = axios.create({
  baseURL: process.env.REACT_APP_UMD_BACK_END_DOMAIN || "/umd-service/api",
});

export type UnsubscribeBranding = {
  entity_name: string | null;
  entity_logo: string | null;
};

const unsubscribePath = (entityId: string, userId: string, token: string) =>
  `/unsubscribe/${entityId}/${userId}/${token}`;

export const useUnsubscribeInfo = (
  entityId: string,
  userId: string,
  token: string
) => {
  return useQuery<UnsubscribeBranding, AxiosError<any>>(
    ["unsubscribe-info", entityId, userId, token],
    async () => {
      const res = await publicHttp.get(
        unsubscribePath(entityId, userId, token)
      );
      return res?.data?.element as UnsubscribeBranding;
    },
    {
      enabled: !!entityId && !!userId && !!token,
      retry: false,
    }
  );
};

export const useConfirmUnsubscribe = () => {
  return useMutation<
    void,
    AxiosError<any>,
    { entityId: string; userId: string; token: string }
  >(async ({ entityId, userId, token }) => {
    await publicHttp.post(unsubscribePath(entityId, userId, token));
  });
};
